import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { beforeSetupsr6thgzteo9n as beforeSetup } from './ElementWriter.ext.mjs';
import { KiteUiCoroutineScopeHelpers25rj47zs39igb as KiteUiCoroutineScopeHelpers } from './KiteUiCoroutineScopeHelpers.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  None_instance1vdtnxdfytk8h as None_instance,
  plus354lvypr4cqa1 as plus,
  ThemeDerivation3kcl449hwgd5y as ThemeDerivation,
} from '../models/Theme.mjs';
import {
  Companion_getInstance22jtx90tar19r as Companion_getInstance,
  ThemeForElement22lj47hlivf8f as ThemeForElement,
} from './NativeElement.mjs';
import {
  equals2au1ep9vhcato as equals,
  hashCodeq5arwsb9dgti as hashCode,
  protoOf180f3jzyo7rfj as protoOf,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { reactive2xic0rufq5s8n as reactive } from '../../../../../reactive/com/lightningkite/reactive/context/ReactiveContext.mjs';
import { FunctionAdapter3lcrrz3moet5b as FunctionAdapter } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/FunctionAdapter.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { _Dimension___get_value__impl__urhqzrblez9tu1bx9v as _Dimension___get_value__impl__urhqzr } from '../models/data.mjs';
import { StringBuildermazzzhj6kkai as StringBuilder } from '../../../../../kotlin-kotlin-stdlib/kotlin/text/StringBuilderJs.mjs';
import {
  charSequenceLength3278n89t01tmv as charSequenceLength,
  charSequenceGet1vxk1y5n17t1z as charSequenceGet,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/charSequenceJs.mjs';
import { isLetterOrDigit2kuxd9e198haf as isLetterOrDigit } from '../../../../../kotlin-kotlin-stdlib/kotlin/text/charJs.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function themed(_this__u8e3s4, theme) {
  return new (ThemedWriter())(_this__u8e3s4, theme);
}
function dynamicThemed(_this__u8e3s4, calculate) {
  return beforeSetup(_this__u8e3s4, ($this$beforeSetup) => {
    applyDynamicTheme($this$beforeSetup, calculate);
    return Unit_instance;
  });
}
var ThemedWriterClass;
function ThemedWriter() {
  if (ThemedWriterClass === VOID) {
    class $ {
      constructor(base, theme) {
        this.base_1 = base;
        this.theme_1 = theme;
      }
      willAddChild_hz2iwc_k$(element) {
        this.base_1.willAddChild_hz2iwc_k$(element);
        element.set_themeChoice_py59um_k$(element.get_themeChoice_22tyn3_k$().plus_duvq05_k$(this.theme_1));
      }
      get_context_h02k06_k$() {
        return this.base_1.get_context_h02k06_k$();
      }
      addChild_2qpft2_k$(element) {
        this.base_1.addChild_2qpft2_k$(element);
      }
      invoke_bnq13k_k$(_this__u8e3s4, actionToCalculate) {
        return this.base_1.invoke_bnq13k_k$(_this__u8e3s4, actionToCalculate);
      }
      get_coroutineContext_115oqo_k$() {
        return this.base_1.get_coroutineContext_115oqo_k$();
      }
    }
    initMetadataForClass($, 'ThemedWriter', VOID, VOID, [KiteUiCoroutineScopeHelpers()]);
    ThemedWriterClass = $;
  }
  return ThemedWriterClass;
}
function applyDynamicTheme(_this__u8e3s4, calculate) {
  var choice = {_v: None_instance};
  var native = _this__u8e3s4.get_underlyingNativeElement_vngz33_k$();
  var tmp = native.themePipeline_1;
  var tmp_0 = Companion_getInstance().dynamicChoice_1;
  var tmp_1 = (it) => choice._v;
  tmp.add_n6yx8s_k$(tmp_0, new (sam$com_lightningkite_kiteui_views_NativeElementCommonCode_ThemePipeline_ThemeForElement$0())(tmp_1));
  reactive(_this__u8e3s4, VOID, ($this$reactive) => {
    // Inline function 'com.lightningkite.reactive.context.TypedReactiveContext.invoke' call
    var tmp0_elvis_lhs = calculate($this$reactive);
    var newChoice = tmp0_elvis_lhs == null ? None_instance : tmp0_elvis_lhs;
    var tmp;
    if (!equals(newChoice, choice._v)) {
      choice._v = newChoice;
      native.refreshTheming_1agefv_k$();
      tmp = Unit_instance;
    }
    return Unit_instance;
  });
}
function get_bold(_this__u8e3s4) {
  // Inline function 'com.lightningkite.kiteui.models.ThemeDerivation' call
  var tmp$ret$0 = new (bold$$inlined$ThemeDerivation$1())();
  return themed(_this__u8e3s4, tmp$ret$0);
}
function textSize(_this__u8e3s4, size) {
  // Inline function 'com.lightningkite.kiteui.models.ThemeDerivation' call
  var tmp$ret$0 = new (textSize$$inlined$ThemeDerivation$1())(size);
  return themed(_this__u8e3s4, tmp$ret$0);
}
var sam$com_lightningkite_kiteui_views_NativeElementCommonCode_ThemePipeline_ThemeForElement$0Class;
function sam$com_lightningkite_kiteui_views_NativeElementCommonCode_ThemePipeline_ThemeForElement$0() {
  if (sam$com_lightningkite_kiteui_views_NativeElementCommonCode_ThemePipeline_ThemeForElement$0Class === VOID) {
    class $ {
      constructor(function_0) {
        this.function_1 = function_0;
      }
      get_31089n_k$(element) {
        return this.function_1(element);
      }
      getFunctionDelegate_jtodtf_k$() {
        return this.function_1;
      }
      equals(other) {
        var tmp;
        if (!(other == null) ? isInterface(other, ThemeForElement()) : false) {
          var tmp_0;
          if (!(other == null) ? isInterface(other, FunctionAdapter()) : false) {
            tmp_0 = equals(this.getFunctionDelegate_jtodtf_k$(), other.getFunctionDelegate_jtodtf_k$());
          } else {
            tmp_0 = false;
          }
          tmp = tmp_0;
        } else {
          tmp = false;
        }
        return tmp;
      }
      hashCode() {
        return hashCode(this.getFunctionDelegate_jtodtf_k$());
      }
    }
    initMetadataForClass($, 'sam$com_lightningkite_kiteui_views_NativeElementCommonCode_ThemePipeline_ThemeForElement$0', VOID, VOID, [ThemeForElement(), FunctionAdapter()]);
    sam$com_lightningkite_kiteui_views_NativeElementCommonCode_ThemePipeline_ThemeForElement$0Class = $;
  }
  return sam$com_lightningkite_kiteui_views_NativeElementCommonCode_ThemePipeline_ThemeForElement$0Class;
}
var bold$$inlined$ThemeDerivation$1Class;
function bold$$inlined$ThemeDerivation$1() {
  if (bold$$inlined$ThemeDerivation$1Class === VOID) {
    class $ {
      invoke_h6mny6_k$(theme) {
        return theme.copy$default_vpegf4_k$('bold', VOID, theme.font_1.copy$default_d05kcn_k$(VOID, VOID, true)).withoutBack_1;
      }
    }
    protoOf($).plus_duvq05_k$ = plus;
    initMetadataForClass($, VOID, VOID, VOID, [ThemeDerivation()]);
    bold$$inlined$ThemeDerivation$1Class = $;
  }
  return bold$$inlined$ThemeDerivation$1Class;
}
var textSize$$inlined$ThemeDerivation$1Class;
function textSize$$inlined$ThemeDerivation$1() {
  if (textSize$$inlined$ThemeDerivation$1Class === VOID) {
    class $ {
      constructor($size) {
        this.$size_1 = $size;
      }
      invoke_h6mny6_k$(theme) {
        // Inline function 'kotlin.text.filter' call
        var tmp0 = _Dimension___get_value__impl__urhqzr(this.$size_1).toString();
        // Inline function 'kotlin.text.filterTo' call
        var destination = StringBuilder().new_kotlin_text_StringBuilder_u46mrb_k$();
        var inductionVariable = 0;
        var last = charSequenceLength(tmp0);
        if (inductionVariable < last)
          do {
            var index = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            var element = charSequenceGet(tmp0, index);
            if (isLetterOrDigit(element)) {
              destination.append_58al37_k$(element);
            }
          }
           while (inductionVariable < last);
        var tmp$ret$1 = destination.toString();
        return theme.copy$default_vpegf4_k$('textSize' + tmp$ret$1, VOID, theme.font_1.copy$default_cfilcw_k$(VOID, VOID, VOID, VOID, VOID, VOID, this.$size_1)).withoutBack_1;
      }
    }
    protoOf($).plus_duvq05_k$ = plus;
    initMetadataForClass($, VOID, VOID, VOID, [ThemeDerivation()]);
    textSize$$inlined$ThemeDerivation$1Class = $;
  }
  return textSize$$inlined$ThemeDerivation$1Class;
}
//region block: exports
export {
  get_bold as get_bold3d63kt1t4c9r5,
  dynamicThemed as dynamicThemed3lsusnjffkq9e,
  textSize as textSize2lsj2v924xul5,
  themed as themed2vu67ornd4jps,
};
//endregion

//# sourceMappingURL=themeDerivations.mjs.map
